module.exports = __webpack_public_path__ + "img/晴.7f9eab0d.png";